"use client";

import { cn } from "../../lib";
import type { MediaPlayerTheme } from "./media-player-theme";

export const MEDIA_PLAYER_PLAYBACK_RATES = [
	0.5, 0.75, 1, 1.25, 1.5, 2,
] as const;

export type MediaPlayerPlaybackRate =
	(typeof MEDIA_PLAYER_PLAYBACK_RATES)[number];

export interface MediaPlayerSpeedChipsProps {
	theme: MediaPlayerTheme;
	value: number;
	onChange: (rate: number) => void;
	disabled?: boolean;
	getChipLabel?: (rate: number) => string;
	className?: string;
}

export function MediaPlayerSpeedChips({
	theme,
	value,
	onChange,
	disabled = false,
	getChipLabel = (rate) => `${rate}×`,
	className,
}: MediaPlayerSpeedChipsProps) {
	return (
		<div
			className={cn(
				"flex min-h-8 max-w-full items-center gap-1 overflow-x-auto",
				className,
			)}
			role="group"
			aria-label="Playback speed"
		>
			{MEDIA_PLAYER_PLAYBACK_RATES.map((rate) => {
				const isActive = Math.abs(value - rate) < 0.001;
				return (
					<button
						key={rate}
						type="button"
						disabled={disabled}
						className={cn(
							"min-h-8 shrink-0 rounded-full px-2.5 text-xs font-semibold transition-colors",
							isActive
								? theme.speedChipActiveClassName
								: theme.speedChipInactiveClassName,
							disabled && "cursor-not-allowed opacity-40",
						)}
						aria-pressed={isActive}
						onClick={() => onChange(rate)}
					>
						{getChipLabel(rate)}
					</button>
				);
			})}
		</div>
	);
}
